var _this2 = this;

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import Vue from 'vue'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var FILE_TYPE = {
  IMG: ['jpg', 'png', 'webp', 'jif', 'jpeg']
};
var script = {
  name: 'YFilePreview',
  props: {
    url: {
      type: String,
      "default": ''
    },
    previewSrcList: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      FILE_TYPE: FILE_TYPE,
      showPreview: false,
      isImage: false
    };
  },
  methods: {
    show: function show() {
      var _this = this;

      var url = this.url;
      var hasParams = url.indexOf('?') !== -1;
      url = hasParams ? url.split('?')[0] : url;
      var type = url.split('.').pop();
      type = type.toLowerCase();
      var isImage = FILE_TYPE.IMG.includes(type);
      this.isImage = isImage;
      this.showPreview = true;

      if (isImage) {
        this.$nextTick(function () {
          _newArrowCheck(this, _this);

          this.$refs.view.showViewer = true;
        }.bind(this));
        return;
      }

      this.$nextTick(function () {
        _newArrowCheck(this, _this);

        this.$refs.view.click();
      }.bind(this));
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}
/* script */


var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.showPreview ? _c("div", [_c("div", {
    staticClass: "y-img-view-container"
  }, [_vm.isImage ? _c("el-image", {
    ref: "view",
    staticStyle: {
      width: "0",
      height: "0"
    },
    attrs: {
      "z-index": 3000,
      src: _vm.url,
      "preview-src-list": _vm.previewSrcList.length ? _vm.previewSrcList : [_vm.url]
    }
  }) : _c("a", {
    ref: "view",
    staticStyle: {
      display: "none"
    },
    attrs: {
      href: _vm.url
    }
  })], 1)]) : _vm._e();
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var newInstance = null; // 将vue组件进行构造函数转换

var FilePreviewConstructor = Vue.extend(__vue_component__); // options

var init = function init() {
  _newArrowCheck(this, _this2);

  // 将组件实例化
  newInstance = new FilePreviewConstructor({
    el: document.createElement('div')
  }); // 加载dom

  document.body.appendChild(newInstance.$el);
}.bind(this);

var caller = function caller(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.url = url;

  if (!newInstance) {
    init();
  }

  for (var prop in options) {
    if (options.hasOwnProperty(prop)) {
      newInstance[prop] = options[prop];
    }
  }

  return newInstance.show(options);
};

__vue_component__.install = function (vue) {
  _newArrowCheck(this, _this2);

  vue.prototype.$filePreview = caller.bind(null);
}.bind(this);

var YFilePreview = caller;
export default __vue_component__;
export { YFilePreview };
